import React from "react";
import moment from "moment";

const Comment = ({ comment }) => {
  return (
    <div className="comment p-2 pb-3 my-2 d-flex align-items-center">
      <img
        src={comment?.snippet?.authorProfileImageUrl}
        alt="usericon"
        className="rounded-circle me-3"
      />
      <div className="comment-body">
        <p className="comment-header mb-1">
          {comment?.snippet?.authorDisplayName} |{" "}
          {moment(comment?.snippet?.publishedAt).fromNow()}
        </p>
        <p
          className="mb-0"
          style={{
            textOverflow: "ellipsis",
            maxWidth: "100%",
            overflowWrap: "break-word",
            wordWrap: "break-word",
          }}
        >
          {comment?.snippet?.textDisplay}
        </p>
      </div>
    </div>
  );
};

export default Comment;
